import clsx from "clsx";
import { Checkbox } from "../shared/checkbox";

export function ColorItem({
  name,
  rgb,
  colourCode,
  actions,
  selectedColors,
  setSelectedColors,
}) {
  return (
    <div className="saved-colors-grid-item">
      <div
        className="saved-colors-grid-item__color"
        style={{ backgroundColor: rgb }}
      >
        {actions}
      </div>
      <p className="saved-colors-grid-item__name">{name}</p>
      <p
        className={clsx("saved-colors-grid-item__hex", {
          "saved-colors-grid-item__hex--mb-16": !!selectedColors,
        })}
      >
        {colourCode}
      </p>
      {selectedColors && (
        <Checkbox
          className="shadcn-checkbox saved-colors-grid-item__checkbox"
          checked={selectedColors?.includes(colourCode)}
          onCheckedChange={(checked) => {
            const computedFieldValue = Array.isArray(selectedColors)
              ? selectedColors
              : [];

            return checked
              ? setSelectedColors([...computedFieldValue, colourCode])
              : setSelectedColors(
                  computedFieldValue?.filter((value) => value !== colourCode)
                );
          }}
        />
      )}
    </div>
  );
}
